<div class="row">
    @if (!hideSearch) {
        <div class="col input-with-clear">
            <input type="text" class="form-control" placeholder="Type to filter" [(ngModel)]="filterText" (keyup)="filterTableData()">
            @if (filterText.length) {
            <button type="button" class="btn-close" (click)="filterTableData(true)"></button>
            }
        </div>
    }
    <div class="col-auto mt-2">
        <label>Showing </label>
        <select class="range-chooser" [(ngModel)]="selectedRange" (ngModelChange)="changePage()">
            @for (option of selectMenuOptions; track option) {
            <option>
                {{option}}
            </option>
            }
            <option>
                All
            </option>
        </select>
        <label> of {{filteredTableDataLength}} </label>
        @if (filteredTableDataLength < data.length) {
            <label>
            &nbsp;from {{data.length}}
            </label>
            }
    </div>
</div>
<table class="table table-hover">
    <thead>
        <tr>
            @if (canExpand) {
            <th class="row-expansion"></th>
            }
            @for (column of columns; track column.name; let i = $index) {
            <th class="text-nowrap">
                @if (column.filterable && column.filters && column.filters!.length > 1) {

                <div ngbDropdown class="d-inline-block">
                    @if (thereAreCheckedFilters(column.filters!)) {
                    <i-bs class="toggle-dropdown" [name]="iconNames.ChevronDoubleDown" ngbDropdownToggle></i-bs>
                    } @else {

                    <i-bs class="toggle-dropdown" [name]="iconNames.ChevronDown" ngbDropdownToggle></i-bs>

                    }
                    <div ngbDropdownMenu>
                        @for (filter of column.filters; track filter; let j = $index) {
                        <div class="m-2">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" [(ngModel)]="filter.checked" [attr.id]="i + '_dropdownCheck_'+ j" (ngModelChange)="filterTableData()">
                                <label class="form-check-label text-nowrap" for="dropdownCheck" [for]="i + '_dropdownCheck_'+ j">
                                    {{ filter.value | stripTags}}
                                </label>
                            </div>
                        </div>
                        }
                    </div>
                </div>

                }
                @if (column.sortable) {
                <div class="column-sorter w-100" (click)="toggleOrder(column)"  [class.text-end]="column.type == 'number'">
                    {{ column.title }}
                    @if (column.sorted?.length) {

                    @if (column.sorted == 'desc') {
                    <i-bs [name]="iconNames.SortAlphaDownAlt"></i-bs>
                    }
                    @if (column.sorted == 'asc') {
                    <i-bs [name]="iconNames.SortAlphaUpAlt"></i-bs>
                    }

                    }
                </div>
                } @else {

                <div class="text-nowrap w-100" (click)="$event.stopPropagation()" [class.text-end]="column.type == 'number'">
                    {{ column.title }}
                </div>

                }
            </th>
            }
        </tr>
    </thead>
    <tbody>
        @for (row of filteredTableData; track row; let i = $index) {

        @if (start <= i && i <=end) { <tr>
            @if (canExpand) {
            <td class="row-expansion" (click)="isExpanded[ i ] = ! isExpanded[ i ]">
                @if (row['expansion']?.length) {

                <i-bs [name]="iconNames.ChevronDown" [@openClose]="isExpanded[i] ? 'open' : 'closed'" class="d-inline-block"></i-bs>

                }
            </td>
            }
            @for (column of columns; track column; let i = $index) {



            @switch (column.type) {
            @case ('text') {
            <td [innerHTML]="row[column.name]"></td>
            }
            @case ('number') {
            <td class="text-end">{{ row[column.name] | number }}</td>
            }
            @case ('date') {
            <td>
                {{ row[column.name] | date }}
            </td>
            }
            @case ('email') {
            <td>
                @if (row[column.name]) {
                <a target="_blank" href="email:{{row[column.name]}}"><i-bs [name]="iconNames.EnvelopeAt"></i-bs>&nbsp;{{row[column.name]}}</a>
                }
            </td>
            }
            @case ('web') {
            <td>
                @if (row[column.name]) {
                <a target="_blank" [href]="row[column.name]"><i-bs [name]="iconNames.BrowserChrome"></i-bs>&nbsp;Web</a>
                }
            </td>
            }
            @case ('tel') {
            <td>
                @if (row[column.name]) {
                <a target="_blank" href="tel:{{row[column.name]}}"><i-bs [name]="iconNames.TelephoneOutbound"></i-bs>&nbsp;{{row[column.name] | phone:'US'}}</a>
                }
            </td>
            }
            @case ('linkedin') {
            <td>
                @if (row[column.name]) {

                <a target="_blank" [href]="row[column.name]" [ngbPopover]="linkedIn" [popoverContext]="{linkedin : getLinkedInHandle(row[column.name])}" popoverClass="linkedin-popover" triggers="mouseenter" [autoClose]="'outside'" [openDelay]="200">
                    <i-bs [name]="iconNames.Linkedin"></i-bs>&nbsp;LinkedIn
                </a>

                }
            </td>
            }
            @case ('template') {
            <td>
                <ng-container [ngTemplateOutlet]="valueTemplates[column.name]!" [ngTemplateOutletContext]="{ value: row[column.name], i, expanded: row['expanded'] }">
                </ng-container>
            </td>
            }
            }


            }
            </tr>
            @if (canExpand && row['expansion'] && isExpanded[i]) {
            <tr>
                <td colspan="100">
                    <div class="collapsible">
                        <ng-container [ngTemplateOutlet]="expansionTemplate" [ngTemplateOutletContext]="{ row }">
                        </ng-container>
                    </div>
                </td>
            </tr>
            }

            }


            }
    </tbody>
</table>

<ng-template #linkedIn let-linkedin="linkedin">
    <linked-in [handle]="linkedin"></linked-in>
</ng-template>